import { updateOrg, xflowPurposeCodeUpdate } from "../../../services/httpCalls"
import Cookies from "js-cookie"
import { cleanObject } from "../clean-object";

export const handleFinish = async ({
    form,
    notify,
    values,
    iseefc,
    website,
    addAddress,
    addressIds,
    flagAddress,
    isOptInward,
    handleChange,
    addressThere,
    isEditActive,
    setShowLoader,
    updateAddress,
    socialWebsite,
    selectionValue,
    isXflowActive
}) => {

    const getXflowPurposeCodeObject = (data) => {
        let xflowPurposeCode = []
            data?.map((item) => {
              xflowPurposeCode.push({
                code: item,
              })
            })
      
            return xflowPurposeCode;
      }

    let getTransactionType = () => {
        switch(selectionValue) {
        case 'inward' : return "RECEIVE_MONEY";
        case 'outward': return "SEND_MONEY";
        case 'both': return "SEND_AND_RECEIVE_MONEY";
        default: return null
       }
    }

    let orgId = localStorage.getItem("orgId")
    let data = {
        panNumber: values?.panNumber,
        name: values?.legalName,
        gstNumber: values?.gstNumber,
        natureOfBusiness: values.natureOfBussiness,
        companyType: values.companyType,
        status: "DRAFT_CORPORATE_DOCS",
        orgEmail: values.comapnyEmail,
        doingBusinessAs: values.doingBusinessAs,
        selectedInwardBankAccountType: iseefc ? "EEFC" : "SIMPLE",
        descriptionForOutward: values?.descriptionForOutward,
        descriptionForInward: values?.descriptionForInward,
        transactionType: getTransactionType(),
    }
    if (isOptInward) {
        data.website = values?.website
        data.checkWebsiteTick = !website.length
        data.checkSocialWebsiteTick = !socialWebsite.length
        data.socialWebsite = values?.socialWebsite
        data.productDescription = values.productDescription
    }
    if (isEditActive) {
        delete data.status
    }
    data.xflowPurposeCodeList = getXflowPurposeCodeObject(form.getFieldValue('xflowPurposeCode'))
    let cleanData = cleanObject(data);
    await updateOrg(cleanData, orgId)
        .then(async res => {
            if (res) {

              // update xflow purpose code when update org succeeds
              if(form.getFieldValue('xflowPurposeCode')?.length){
                if(isXflowActive){
                let orgId = localStorage.getItem("orgId");
                let purposeCode = getXflowPurposeCodeObject(form.getFieldValue('xflowPurposeCode'))
                xflowPurposeCodeUpdate(purposeCode, orgId)
                  .then((res) => {
                    if (res) {
                      notify.success("Xflow purpose code updated !")
                    }
                  })
                  .catch((err) => {
                    if (err) {
                      return err;
                    }
                  })
                }
              }

                let addressData
                if (addressThere) {
                    if (flagAddress) {

                        addressData = {
                            addressLineOne: values.registeredAddress_addressLineOne,
                            addressLineTwo: values.registeredAddress_addressLineTwo,
                            city: values.registeredAddress_city,
                            country: values.registeredAddress_country,
                            pinCode: values.registeredAddress_pinCode.toString(),
                            state: values.registeredAddress_state,
                            type: "REGISTERED"
                        }
                        let cleanAddressData = cleanObject(addressData)
                        updateAddress(cleanAddressData, orgId, addressIds.REGISTERED)

                    }
                } else {

                    addressData = {
                        addressLineOne: values.registeredAddress_addressLineOne,
                        addressLineTwo: values.registeredAddress_addressLineTwo,
                        city: values.registeredAddress_city,
                        country: values.registeredAddress_country,
                        pinCode: values.registeredAddress_pinCode.toString(),
                        state: values.registeredAddress_state,
                        type: "REGISTERED"
                    }
                    let cleanAddressData = cleanObject(addressData)
                    addAddress(cleanAddressData, orgId)
                }
                Cookies.set("currentStage", "3")
                notify.success("CKYC submitted!")
                handleChange(3)
            }
        })
        .finally(async () => {
            setShowLoader(false)
        })
}